import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SalesforceMultipicklistFieldComponent } from './salesforce-multipicklist-field.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule.forChild(),
    MatSelectModule
  ],
  declarations: [
    SalesforceMultipicklistFieldComponent
  ],
  exports: [
    SalesforceMultipicklistFieldComponent
  ]
})
export class SalesforceMultiPicklistModule {}
